import { XMarkIcon } from '@heroicons/react/24/outline';

/**
 * Reusable close button. Uses XMarkIcon from heroicons.
 * @param {function} onClick - Close handler
 * @param {string} [className] - Additional classes
 * @param {string} [size='sm'] - Button size: 'xs', 'sm', 'md'
 * @param {string} [label='Close'] - Aria label
 */
export default function CloseButton({ onClick, className = '', size = 'sm', label = 'Close' }) {
  const iconSize = size === 'xs' ? 'w-4 h-4' : 'w-5 h-5';

  return (
    <button
      onClick={onClick}
      className={`btn btn-ghost btn-${size} btn-circle ${className}`}
      aria-label={label}
    >
      <XMarkIcon className={iconSize} />
    </button>
  );
}
